import script from "./SnackbarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SnackbarComponent.vue?vue&type=script&setup=true&lang=js"

import "./SnackbarComponent.vue?vue&type=style&index=0&id=304b8ac8&lang=css"

const __exports__ = script;

export default __exports__